import React from 'react'
import WizardXpButton from '../../wizard-v2/components/WizardXpButton'
import { createPortal } from 'react-dom';

const StyleStepDesktop = ({
  data,
  handleClick,
  form,
  onContinueClick,
}) => {
  const footerPortal = document.getElementById('wizard-next-button');

  return (
    <div>
      <p className="mb-8 heading-large text-primary">{data.title}</p>
      <div className="wizard-style-step animate-fade-in">
        {data.items.map((item, index) => (
          <WizardXpButton
            key={index}
            label={item.text}
            iconUrl={item.icon}
            onClick={() => handleClick(item)}
            active={form.style?.text === item.text}
            className={`slide-in-bottom animation-delay-${index * 50} font-semibold text-tertiary`}
          />
        ))}
      </div>

      {footerPortal && createPortal(
        <button className="wizard-btn wizard-btn--next" onClick={onContinueClick}>
          {data.buttonText}
          <i className="ri-arrow-right-s-line text-xl leading-none rtl:-scale-x-100" />
        </button>,
        footerPortal
      )}
    </div>
  )
}

export default StyleStepDesktop
